module.exports = __webpack_public_path__ + "static/media/24_tn.ca33ea5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/24_tn.jpg
// module id = 333
// module chunks = 0